import { render, staticRenderFns } from "./WorkflowDag.vue?vue&type=template&id=b6e0b634&"
import script from "./WorkflowDag.vue?vue&type=script&lang=js&"
export * from "./WorkflowDag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports